export const PUBLIC_HEADER_ROUTS = [
  "/sign-in",
  "/sign-up",
  "/terms-of-service",
  "/privacy-policy",
  "/waitlist",
  "/waitlist-success",
];